import { Typography } from '@mui/material';
import * as React from 'react';

import RemoteAutocomplete from '../components/RemoteAutocomplete';

// CP-6723: the user search behind this field already matches first and last names word
// by word, so "Jane Doe" finds Jane Doe. The options used to be labeled by email alone,
// and MUI's default filter then dropped every name match as "No matches". The server's
// result set is the answer; keep it as-is.
export const keepServerMatches = (options) => options;

export const associatedUserName = (user) =>
    [user?.first_name, user?.last_name]
        .map((part) => (part || '').trim())
        .filter(Boolean)
        .join(' ');

// "Jane Doe <jane@example.com>", or just the email for a user without a name.
export const associatedUserLabel = (user) => {
    if (!user) return '';
    const name = associatedUserName(user);
    if (name && user.email) return `${name} <${user.email}>`;
    return name || user.email || `User #${user.id}`;
};

// Dropped from the search text so the label above, typed or pasted back in (as in an
// email header), still finds the user.
const SEARCH_CHARS_TO_IGNORE = ['<', '>'];

const TEXT_FIELD_PROPS = { placeholder: 'Search by name or email' };

const renderAssociatedUserOption = (liProps, user) => {
    const name = associatedUserName(user);
    return (
        <li {...liProps}>
            <div>
                <div>{name || user.email}</div>
                {name && user.email && (
                    <Typography variant="caption" color="textSecondary">
                        {user.email}
                    </Typography>
                )}
            </div>
        </li>
    );
};

const AssociatedUserField = ({ value, onChange, disabled }) => (
    <RemoteAutocomplete
        disabled={disabled}
        resource="user"
        urlSuffix={null}
        label="Associated User"
        variant="filled"
        size="small"
        onChange={onChange}
        getOptionLabel={associatedUserLabel}
        filterOptions={keepServerMatches}
        renderOption={renderAssociatedUserOption}
        searchCharsToIgnore={SEARCH_CHARS_TO_IGNORE}
        textFieldProps={TEXT_FIELD_PROPS}
        value={value ?? null}
    />
);

export default AssociatedUserField;
